module["exports"] = [
  "ukr.net",
  "ex.ua",
  "e-mail.ua",
  "i.ua",
  "meta.ua",
  "yandex.ua",
  "gmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/uk/internet/free_email.js
// module id = 3669
// module chunks = 1610